import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title: "Network visualization \nwith hierarchy",
  subtitle: "Network operations demo",
  text: '<span style="font-weight:bold">OpEx cost reduction</span> —  empowering agents \nwith a comprehensive network view enables \nthem to pinpoint the root cause effectively.',
  label: { iconPath: "start.png", text: "Topology - Network Visualization" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_206"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_204"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 2_R1.mp4",
  pageNumber: "ILO_205",
};

export default DATA_NO_DEMO_ILO2;
